import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  AuthService,
  ButtonsComponent,
  CartService,
  CartsService,
  GungFlow,
  GungFlowService,
  GungModalService,
  NavbarCartService,
  SaveCartModalConfigService
} from 'gung-standard';
import { first } from 'rxjs';
import { CultSummarizeOrderComponent } from '../../cult-summarize-order/cult-summarize-order.component';
import { CheckoutConfigService } from 'gung-standard';

@Component({
    selector: 'cult-checkout-buttons',
    templateUrl: './cult-checkout-buttons.component.html',
    styleUrls: ['./cult-checkout-buttons.component.scss'],
    standalone: false
})
export class CultCheckoutButtonsComponent extends ButtonsComponent implements OnInit {
  public flow: GungFlow;
  isReturNoPrice = false;

  constructor(
    protected navbarCartService: NavbarCartService,
    protected gungModalService: GungModalService,
    protected saveCartModalConfigService: SaveCartModalConfigService,
    protected cartService: CartService,
    protected translationService: TranslateService,
    protected authService: AuthService,
    protected checkoutConfig: CheckoutConfigService,
    protected gungFlowService: GungFlowService,
    protected cartsService: CartsService
  ) {
    super(
      navbarCartService,
      gungModalService,
      saveCartModalConfigService,
      cartService,
      translationService,
      authService,
      checkoutConfig,
      cartsService
    );
  }

  ngOnInit() {
    super.ngOnInit();

    this.gungFlowService
      .getSelectedFlow()
      .pipe(first())
      .subscribe(flow => (this.flow = flow));

    this.authService
      .getCurrentUser()
      .pipe(first())
      .subscribe(user => {
        this.isReturNoPrice = user.roles.includes('RETUR_NOPRICE');
      });
  }

  public get isSubmitStep() {
    return this.allSteps.indexOf(this.currentStep) === this.allSteps.indexOf(CultSummarizeOrderComponent);
  }
}
